import React from "react";
import cns from "classnames";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    color: theme.palette.grey[800],
    fontSize: theme.typography.fontSize * 1.25
  }
}));

export function Subheading(props: TypographyProps) {
  const { className, children, ...rest } = props;
  const classes = useStyles({});
  return (
    <Typography variant="subtitle1" className={cns(classes.root, className)} {...rest}>
      {children}
    </Typography>
  );
}
